import { ComponentStyleConfig, theme } from '@chakra-ui/react';

export const Button: ComponentStyleConfig = {
  defaultProps: {
    variant: 'network',
  },
  variants: {
    link: props => ({
      ...theme.components.Button.variants?.link(props),
      fontSize: 'inherit',
      color: 'blue.800',
      fontWeight: 400,
      _hover: { textDecor: 'none', color: 'dynamic.accent' },
    }),
    shadow: {
      iconSpacing: '1rem',
      bg: 'white',
      color: 'blue.800',
      shadow: '3px 3px 10px #00000065',
      w: 'full',
      fontSize: '1.125rem',
      fontWeight: 400,
      py: '1.5rem',
      justifyContent: 'flex-start',
      _active: { bg: 'white' },
      _hover: { bg: 'white' },
      _loading: { shadow: '3px 3px 10px #00000065', justifyContent: 'center' },
      _disabled: { shadow: '3px 3px 10px #00000065' },
      transitionDuration: 'all 0s',
    },
    ghost: props => ({
      ...theme.components.Button.variants?.ghost(props),
      fontSize: 'inherit',
      color: 'blue.800',
      fontWeight: 400,
      _hover: { bg: 'transparent' },
      _active: { bg: 'transparent' },
    }),
    network: {
      bg: 'dynamic.accent',
      color: 'white',
      fontWeight: 400,
      size: 'lg',
      fontSize: '1.125rem',
      rounded: 'xl',
      w: 'full',
      transition: 'filter 0.2s ease-in-out',
      shadow: '3px 3px 10px #00000065',
      _loading: {
        bg: 'dynamic.accent',
        filter: 'brightness(0.9)',
        _hover: {
          bg: 'dynamic.accent',
          filter: 'brightness(0.9)',
        },
      },
      _hover: {
        bg: 'dynamic.accent',
      },
    },
    icon: {
      bg: 'dynamic.accent',
      color: 'white',
      fontWeight: 400,
      transition: 'filter 0.2s ease-in-out',
      _loading: {
        bg: 'dynamic.accent',
        filter: 'brightness(0.9)',
        _hover: {
          bg: 'dynamic.accent',
          filter: 'brightness(0.9)',
        },
      },
      _hover: {
        bg: 'dynamic.accent',
      },
    },
  },
};
